




















import { Component, Vue, Prop } from 'vue-property-decorator';
import ImageUploader from 'vue-image-upload-resize';
import PictureService from '@/services/picture';

@Component({
    components: {
        ImageUploader,
    },
})
export default class Uploader extends Vue {
    @Prop({ default: 'pictures' })
    type: string;

    @Prop({ default: 'uploader' })
    id: string;

    pictureService = new PictureService();

    upload(picture: File) {
        this.pictureService.upload(picture, this.type)
            .then((response: any) => this.$emit('change', response.url));
    }

    uploading() {
        this.$emit('uploading');
    }
}
